(() => {
  const root = document.querySelector('[data-upsell-root]');
  if (!root) return;

  const loadingEl = root.querySelector('[data-upsell-loading]');
  const emptyEl = root.querySelector('[data-upsell-empty]');
  const errorEl = root.querySelector('[data-upsell-error]');
  const contentEl = root.querySelector('[data-upsell-content]');
  const purchaseErrorEl = root.querySelector('[data-upsell-purchase-error]');

  const cartEl = root.querySelector('[data-upsell-cart]');
  const planCards = Array.from(root.querySelectorAll('[data-upsell-plan]'));

  const storeDomain = root.dataset.storeDomain || 'nutrition-su.myshopify.com';
  const apiVersion = root.dataset.apiVersion || '2025-10';
  const token = root.dataset.storefrontToken || '76d349f53add8fb2f0560350acfc089f';
  const sellingPlanId = root.dataset.sellingPlanId || '3487203430';
  const allowedPricingModes = new Set(['first_cycle', 'always_15', 'first_cycle_60_20']);
  const rawPricingMode = root.dataset.pricingMode;
  const pricingMode = allowedPricingModes.has(rawPricingMode) ? rawPricingMode : 'first_cycle';
  const routesRoot = window.Shopify?.routes?.root || '/';

  const params = new URLSearchParams(window.location.search);
  const itemsParam = params.get('items');

  const selectedSellingPlanIds = new Map();
  const buttonItemsMap = new Map();

  const showState = (state) => {
    if (loadingEl) loadingEl.hidden = state !== 'loading';
    if (emptyEl) emptyEl.hidden = state !== 'empty';
    if (errorEl) errorEl.hidden = state !== 'error';
    if (contentEl) contentEl.hidden = state !== 'ready';

    if (state === 'ready') {
      if (loadingEl) loadingEl.hidden = true;
      if (emptyEl) emptyEl.hidden = true;
      if (errorEl) errorEl.hidden = true;
    }
  };

  const setPurchaseError = (message) => {
    if (!purchaseErrorEl) return;
    purchaseErrorEl.textContent = message || '';
    purchaseErrorEl.hidden = !message;
  };

  const formatPrice = (amount, currencyCode) => {
    if (!amount || !currencyCode) return '価格未取得';
    try {
      return new Intl.NumberFormat('ja-JP', { style: 'currency', currency: currencyCode }).format(Number(amount));
    } catch (e) {
      return `${amount} ${currencyCode}`;
    }
  };

  const escapeHtml = (value) => String(value ?? '').replace(/[&<>"']/g, (char) => ({
    '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;'
  }[char]));

  const summarizeText = (value, maxLength = 90) => {
    const text = String(value || '').replace(/■\s*商品説明/g, '').replace(/商品説明/g, '').replace(/\s+/g, ' ').trim();
    if (!text) return '今のあなたに必要な栄養素を補うためのサプリメントです。';
    return text.length > maxLength ? `${text.slice(0, maxLength)}…` : text;
  };

  const supplementDescriptions = [
    { keywords: ['マグネシウム'], text: '筋肉や神経の機能維持、エネルギー代謝に欠かせないミネラル' },
    { keywords: ['ヘム鉄', '鉄'], text: '酸素を全身に運ぶ重要ミネラル' },
    { keywords: ['亜鉛', 'Zn'], text: '細胞分裂や酵素反応を支える必須ミネラル' },
    { keywords: ['ビタミンD', 'Vitamin D'], text: 'カルシウム吸収を助ける脂溶性ビタミン' },
    { keywords: ['ビタミンC', 'Vitamin C'], text: '美容と健康維持、抗酸化サポートに役立つ水溶性ビタミン' },
    { keywords: ['ビタミンB', 'Vitamin B', 'B群'], text: 'エネルギー産生を支える補酵素群' },
    { keywords: ['葉酸'], text: '赤血球の形成や細胞の生まれ変わりを支えるビタミンB群の一種' },
    { keywords: ['クリルオイル', 'DHA', 'EPA', 'オメガ3', 'オメガ３', 'オメガ3脂肪酸', 'Omega'], text: '体内で作れない必須脂肪酸' },
    { keywords: ['コエンザイム', 'コエンザイムQ10', 'CoQ10', 'Coenzyme', 'ユビキノン'], text: '細胞の発電所を支える補酵素' },
    { keywords: ['乳酸菌', 'プロバイオティクス'], text: '腸内環境を整え、内側からの健康維持をサポートする善玉菌' },
    { keywords: ['カルシウム', 'Ca'], text: '骨や歯の形成を支え、健康な体づくりに欠かせないミネラル' },
    { keywords: ['マルチビタミン', 'マルチミネラル'], text: '不足しがちなビタミン・ミネラルをまとめて補うベースサプリ' }
  ];

  const getSupplementDescription = (productTitle, variantTitle, fallbackDescription) => {
    const target = `${productTitle || ''} ${variantTitle || ''}`.toLowerCase();
    const matched = supplementDescriptions.find((item) =>
      item.keywords.some((keyword) => target.includes(keyword.toLowerCase()))
    );
    return matched ? matched.text : summarizeText(fallbackDescription);
  };

  const parseItems = (raw) => {
    if (!raw) return [];
    return raw.split(',').map((chunk) => {
      const [idRaw, qtyRaw] = chunk.split(':');
      const id = (idRaw || '').trim();
      if (!/^\d+$/.test(id)) return null;
      const qty = parseInt((qtyRaw || '').trim(), 10);
      return { id, qty: Number.isFinite(qty) && qty > 0 ? qty : 1 };
    }).filter(Boolean);
  };

  const subToRegularMap = {
    '43456652116070': '42836103561318',
    '43456652148838': '42835651788902',
    '43456651591782': '42836121288806',
    '43456651821158': '42836113981542',
    '43456651755622': '42836119093350',
    '43456651853926': '42836110508134',
  };

  const firstCycleSubscriptionPriceMap = {
    '43456652148838': { regular: 3180, first: 1620, recurring: 2700 },
    '43456652116070': { regular: 2880, first: 1470, recurring: 2450 },
    '43456651853926': { regular: 4480, first: 2280, recurring: 3800 },
    '43456651821158': { regular: 3880, first: 1980, recurring: 3300 },
    '43456651755622': { regular: 5680, first: 2900, recurring: 4830 },
    '43456651591782': { regular: 3880, first: 1980, recurring: 3300 },
  };

  const always15SubscriptionPriceMap = {
    '43456652148838': { regular: 3180, first: 2700, recurring: 2700 },
    '43456652116070': { regular: 2880, first: 2450, recurring: 2450 },
    '43456651853926': { regular: 4480, first: 3800, recurring: 3800 },
    '43456651821158': { regular: 3880, first: 3300, recurring: 3300 },
    '43456651755622': { regular: 5680, first: 4830, recurring: 4830 },
    '43456651591782': { regular: 3880, first: 3300, recurring: 3300 },
  };

  const firstCycle6020SubscriptionPriceMap = {
    '43456652148838': { regular: 3180, first: 1270, recurring: 2540 },
    '43456652116070': { regular: 2880, first: 1150, recurring: 2300 },
    '43456651853926': { regular: 4480, first: 1790, recurring: 3580 },
    '43456651821158': { regular: 3880, first: 1550, recurring: 3100 },
    '43456651755622': { regular: 5680, first: 2270, recurring: 4540 },
    '43456651591782': { regular: 3880, first: 1550, recurring: 3100 },
  };

  const subscriptionPriceMaps = {
    first_cycle: firstCycleSubscriptionPriceMap,
    always_15: always15SubscriptionPriceMap,
    first_cycle_60_20: firstCycle6020SubscriptionPriceMap,
  };
  const subscriptionPriceMap = subscriptionPriceMaps[pricingMode] || firstCycleSubscriptionPriceMap;

  const regularToSubMap = Object.fromEntries(
    Object.entries(subToRegularMap).map(([subId, regularId]) => [regularId, subId])
  );

  const normalizeItems = (planItems, variantMap) => (
    planItems.map((item) => ({
      ...item,
      id: variantMap[item.id] || item.id
    }))
  );

  const getNumericSellingPlanId = (gid) => {
    const match = String(gid || '').match(/SellingPlan\/(\d+)/);
    return match ? match[1] : gid;
  };

  const getAllocationFirstPrice = (allocation) => {
    const amount = allocation?.node?.priceAdjustments?.[0]?.price?.amount;
    const price = Number(amount);
    return Number.isFinite(price) ? Math.round(price) : null;
  };

  const findTargetAllocation = (variantId, allocations) => {
    const expectedPrices = subscriptionPriceMap[variantId];
    if (expectedPrices) {
      const fixedPriceAllocation = allocations.find((edge) =>
        getAllocationFirstPrice(edge) === expectedPrices.first
      );
      if (fixedPriceAllocation) return fixedPriceAllocation;
    }

    if (pricingMode !== 'first_cycle') return null;

    return allocations.find((edge) =>
      edge.node.sellingPlan.id.includes(sellingPlanId)
    ) || allocations[0];
  };

  const toRoute = (path) => `${routesRoot}${path.replace(/^\//, '')}`;

  const items = normalizeItems(parseItems(itemsParam), regularToSubMap).slice(0, 3);
  if (items.length === 0) {
    showState('empty');
    return;
  }

  const variantIds = Array.from(new Set(items.map((item) => item.id)));
  const gidList = variantIds.map((id) => {
    try { return btoa(`gid://shopify/ProductVariant/${id}`); } catch (e) { return `gid://shopify/ProductVariant/${id}`; }
  });

  const query = `query VariantNodes($ids: [ID!]!) {
    nodes(ids: $ids) {
      ... on ProductVariant {
        id
        title
        price { amount currencyCode }
        compareAtPrice { amount currencyCode }
        sellingPlanAllocations(first: 10) {
          edges {
            node {
              sellingPlan { id name }
              priceAdjustments {
                price { amount currencyCode }
                compareAtPrice { amount currencyCode }
              }
            }
          }
        }
        product {
          title vendor productType description tags onlineStoreUrl
          featuredImage { url altText }
        }
      }
    }
  }`;

  const getItemView = (item, variantMap) => {
    const data = variantMap.get(item.id);
    if (!data) return null;

    const productTitle = data?.product?.title || '商品名未取得';
    const variantTitle = data?.title || '';
    const displayName = variantTitle && variantTitle !== 'Default Title'
      ? `${productTitle} - ${variantTitle}` : productTitle;
    const productType = 'ワカサプリ';
    const productDescription = getSupplementDescription(productTitle, variantTitle, data?.product?.description);
    const imageUrl = data?.product?.featuredImage?.url || '';
    const imageAlt = data?.product?.featuredImage?.altText || displayName;
    const allocations = data?.sellingPlanAllocations?.edges || [];
    const targetAllocation = findTargetAllocation(item.id, allocations);
    const targetSellingPlanId = getNumericSellingPlanId(targetAllocation?.node?.sellingPlan?.id);
    if (targetSellingPlanId) selectedSellingPlanIds.set(item.id, targetSellingPlanId);

    const fixedPrices = subscriptionPriceMap[item.id];
    const subPriceAmount = fixedPrices?.first
      || targetAllocation?.node?.priceAdjustments?.[0]?.price?.amount
      || data?.price?.amount;
    const compareAtPriceAmount = targetAllocation?.node?.priceAdjustments?.[0]?.compareAtPrice?.amount
      || data?.compareAtPrice?.amount;
    const regularPriceAmount = fixedPrices?.regular || compareAtPriceAmount || data?.price?.amount;
    const recurringPriceAmount = fixedPrices?.recurring || regularPriceAmount;

    return {
      id: item.id,
      qty: item.qty,
      title: displayName,
      productType,
      description: productDescription,
      imageUrl,
      imageAlt,
      currencyCode: data?.price?.currencyCode || 'JPY',
      firstPrice: Number(subPriceAmount),
      recurringPrice: Number(recurringPriceAmount),
      regularPrice: Number(regularPriceAmount),
      sellingPlanName: targetAllocation?.node?.sellingPlan?.name || '毎月配達',
      hasSellingPlan: Boolean(targetSellingPlanId)
    };
  };

  const renderProductItem = (itemView, label) => {
    if (!itemView) return '';
    const imageHtml = itemView.imageUrl
      ? `<img src="${escapeHtml(itemView.imageUrl)}" alt="${escapeHtml(itemView.imageAlt)}" class="mtu__item-image">` : '';
    const productMainClass = itemView.imageUrl ? 'mtu__product-main' : 'mtu__product-main mtu__product-main--no-image';
    const quantityText = itemView.qty > 1 ? ` × ${itemView.qty}` : '';

    return `
      <li class="mtu__item">
        <div class="${productMainClass}">
          ${imageHtml}
          <div class="mtu__product-info">
            <div class="mtu__product-label">${escapeHtml(label)}</div>
            <div class="mtu__product-brand">${escapeHtml(itemView.productType)}</div>
            <div class="mtu__product-title">${escapeHtml(itemView.title)}${escapeHtml(quantityText)}</div>
            <p class="mtu__product-desc">${escapeHtml(itemView.description)}</p>
          </div>
        </div>
      </li>
    `;
  };

  const renderCartItem = (container, item, itemView) => {
    if (!container || !itemView) return;
    const quantityText = item.qty > 1 ? item.qty : 1;
    const imageHtml = itemView.imageUrl
      ? `<img src="${escapeHtml(itemView.imageUrl)}" alt="${escapeHtml(itemView.imageAlt)}" class="upsell-cart-item__image">`
      : '<div class="upsell-cart-item__image" aria-hidden="true"></div>';
    const firstTotal = Number.isFinite(itemView.firstPrice) ? itemView.firstPrice * item.qty : 0;
    const recurringTotal = Number.isFinite(itemView.recurringPrice) ? itemView.recurringPrice * item.qty : 0;

    const discountPct = (price) => {
      if (!Number.isFinite(price) || !Number.isFinite(itemView.regularPrice) || itemView.regularPrice <= 0) return null;
      const pct = Math.round((1 - price / itemView.regularPrice) * 100);
      return pct > 0 ? pct : null;
    };
    const firstPct = discountPct(itemView.firstPrice);
    const recurringPct = discountPct(itemView.recurringPrice);

    const priceboxHeadline = (badge, pct, total) => `
            <div class="upsell-cart-pricebox__headline">
              <span class="upsell-cart-pricebox__badge">${badge}</span>
              ${pct ? `<span class="upsell-cart-pricebox__off"><strong>${pct}</strong>%OFF</span>` : ''}
              <span class="upsell-cart-pricebox__price">${formatPrice(total, itemView.currencyCode)}</span>
              <span class="upsell-cart-pricebox__tax">(税込)</span>
            </div>`;

    const priceboxHtml = pricingMode === 'always_15'
      ? `${priceboxHeadline('定期', firstPct, firstTotal)}
            <p class="upsell-cart-pricebox__caption">定期価格・送料込み</p>`
      : `${priceboxHeadline('初回限定', firstPct, firstTotal)}
            <p class="upsell-cart-pricebox__caption">初回お届け価格・送料込み</p>
            ${recurringTotal ? `<div class="upsell-cart-pricebox__recurring">2ヶ月目以降は ${recurringPct ? `${recurringPct}%OFF で ` : ''}${formatPrice(recurringTotal, itemView.currencyCode)}（税込）</div>` : ''}`;

    container.innerHTML = `
      <div class="upsell-cart-item">
        <div class="upsell-cart-item__media">
          ${imageHtml}
        </div>
        <div class="upsell-cart-item__detail">
          <h3 class="upsell-cart-item__title">${escapeHtml(itemView.title)}</h3>
          <p class="upsell-cart-item__frequency">毎月お届け</p>
          <div class="upsell-cart-pricebox">
            ${priceboxHtml}
          </div>
        </div>
        <div class="upsell-cart-item__line-price">${formatPrice(firstTotal, itemView.currencyCode)}</div>
        <div class="upsell-cart-item__actions">
          <div class="upsell-cart-qty" aria-label="数量 ${quantityText}">
            <span class="upsell-cart-qty__mark">-</span>
            <span>${quantityText}</span>
            <span class="upsell-cart-qty__mark">+</span>
          </div>
          <span class="upsell-cart-item__remove">削除</span>
        </div>
      </div>
    `;
  };

  const getTotals = (planItems, itemViewMap) => {
    let firstTotal = 0;
    let recurringTotal = 0;
    let regularTotal = 0;
    let currencyCode = 'JPY';
    let ready = planItems.length > 0;

    planItems.forEach((item) => {
      const itemView = itemViewMap.get(item.id);
      if (!itemView || !itemView.hasSellingPlan) ready = false;
      if (!itemView) return;
      currencyCode = itemView.currencyCode || currencyCode;
      if (Number.isFinite(itemView.firstPrice)) firstTotal += itemView.firstPrice * item.qty;
      if (Number.isFinite(itemView.recurringPrice)) recurringTotal += itemView.recurringPrice * item.qty;
      if (Number.isFinite(itemView.regularPrice)) regularTotal += itemView.regularPrice * item.qty;
    });

    return { firstTotal, recurringTotal, regularTotal, currencyCode, ready };
  };

  const setSummaryPrice = (priceEl, recurringEl, regularEl, planItems, itemViewMap) => {
    const totals = getTotals(planItems, itemViewMap);
    if (priceEl) priceEl.textContent = totals.firstTotal ? formatPrice(totals.firstTotal, totals.currencyCode) : '';
    if (recurringEl) recurringEl.textContent = totals.recurringTotal ? formatPrice(totals.recurringTotal, totals.currencyCode) : '';
    if (regularEl) regularEl.textContent = totals.regularTotal ? formatPrice(totals.regularTotal, totals.currencyCode) : '';
    return totals;
  };

  const setButtonItems = (button, planItems, itemViewMap) => {
    if (!button) return;
    const totals = getTotals(planItems, itemViewMap);
    buttonItemsMap.set(button, planItems);
    button.dataset.upsellReady = totals.ready ? 'true' : 'false';
    button.disabled = !totals.ready;
  };

  const renderList = (listEl, planItems, itemViewMap) => {
    if (!listEl) return;
    const additionalItems = planItems.slice(1);
    const rankLabels = ['不足度2位', '不足度3位'];
    listEl.innerHTML = additionalItems
      .map((item, index) => renderProductItem(itemViewMap.get(item.id), rankLabels[index] || '追加サプリ'))
      .join('');
  };

  const renderUpsell = (variantMap) => {
    const itemViewMap = new Map();
    items.forEach((item) => {
      const itemView = getItemView(item, variantMap);
      if (itemView) itemViewMap.set(item.id, itemView);
    });

    if (cartEl && items[0]) {
      const soloItems = [items[0]];
      const countEl = cartEl.querySelector('[data-upsell-cart-count]');
      const cartItemView = itemViewMap.get(items[0].id);
      if (countEl) countEl.textContent = `(${items[0].qty})`;
      renderCartItem(cartEl.querySelector('[data-upsell-cart-item]'), items[0], cartItemView);
      setSummaryPrice(
        cartEl.querySelector('[data-upsell-cart-price]'),
        null,
        null,
        soloItems,
        itemViewMap
      );
      setButtonItems(cartEl.querySelector('[data-upsell-solo-button]'), soloItems, itemViewMap);
    }

    planCards.forEach((card) => {
      const plan = card.getAttribute('data-upsell-plan');
      const planItems = plan === 'three' ? items.slice(0, 3) : items.slice(0, 2);
      const minimumItems = plan === 'three' ? 3 : 2;
      if (items.length < minimumItems) {
        card.hidden = true;
        return;
      }

      card.hidden = false;
      renderList(card.querySelector('[data-upsell-plan-items]'), planItems, itemViewMap);
      setSummaryPrice(
        card.querySelector('[data-upsell-plan-price]'),
        card.querySelector('[data-upsell-plan-recurring]'),
        card.querySelector('[data-upsell-plan-regular]'),
        planItems,
        itemViewMap
      );
      setButtonItems(card.querySelector('[data-upsell-plan-button]'), planItems, itemViewMap);
    });
  };

  const setReadyButtonsDisabled = (disabled) => {
    root.querySelectorAll('button[data-upsell-ready="true"]').forEach((button) => {
      button.disabled = disabled;
    });
  };

  const purchaseItems = async (button, planItems) => {
    if (!planItems || planItems.length === 0 || button.disabled) return;

    const missingSellingPlan = planItems.some((item) => !selectedSellingPlanIds.get(item.id));
    if (missingSellingPlan) {
      setPurchaseError('定期購入プランを取得できませんでした。時間をおいて再度お試しください。');
      return;
    }

    setPurchaseError('');
    setReadyButtonsDisabled(true);

    try {
      const response = await fetch(toRoute('/cart/add.js'), {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          items: planItems.map((item) => {
            const sellingPlan = selectedSellingPlanIds.get(item.id);
            return {
              id: Number(item.id),
              quantity: item.qty,
              selling_plan: /^\d+$/.test(String(sellingPlan)) ? Number(sellingPlan) : sellingPlan
            };
          })
        })
      });
      const payload = await response.json().catch(() => null);

      if (!response.ok) {
        throw new Error(payload?.description || payload?.message || 'カートへの追加に失敗しました。');
      }

      window.location.assign(toRoute('/checkout'));
    } catch (error) {
      console.error('Upsell checkout error:', error);
      setPurchaseError(error?.message || '購入処理に失敗しました。時間をおいて再度お試しください。');
      setReadyButtonsDisabled(false);
    }
  };

  root.addEventListener('click', (event) => {
    const button = event.target instanceof Element
      ? event.target.closest('[data-upsell-solo-button], [data-upsell-plan-button]')
      : null;
    if (!button) return;

    event.preventDefault();
    purchaseItems(button, buttonItemsMap.get(button) || []);
  });

  showState('loading');

  fetch(`https://${storeDomain}/api/${apiVersion}/graphql.json`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'X-Shopify-Storefront-Access-Token': token },
    body: JSON.stringify({ query, variables: { ids: gidList } })
  })
    .then((res) => { if (!res.ok) throw new Error('Storefront API request failed'); return res.json(); })
    .then((payload) => {
      if (payload?.errors?.length) throw new Error('Storefront API returned errors');
      const nodes = payload?.data?.nodes || [];
      const variantMap = new Map();

      nodes.forEach((node) => {
        if (!node?.id) return;
        const match = node.id.match(/ProductVariant\/(\d+)/);
        if (match) variantMap.set(match[1], node);
      });

      const missingVariants = items.filter((item) => !variantMap.has(item.id)).length;
      if (missingVariants > 0 && errorEl) {
        errorEl.textContent = `商品情報を取得できないIDが${missingVariants}件あります。`;
        showState('error');
        return;
      }

      renderUpsell(variantMap);
      showState('ready');
    })
    .catch((error) => {
      console.error('Storefront API error:', error);
      if (errorEl) errorEl.textContent = '商品情報の取得に失敗しました。';
      showState('error');
    });
})();
